import type { Team } from '@/entities/team';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getTeams = (params?: RequestMeta): Promise<{ teams: Team[]; meta: ResponseMeta }> =>
  request({
    url: '/teams/',
    params,
  });
